// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
	--color-success-front: #30b471;
	--color-warning: #c69347;
	--color-error-front: #721c24;
	--color-error-back: #f8d7da;
	--color-error-border: #f5c6cb;

}

.rcdevsLogo {
	height: 44px;
	left: 15px;
	position: absolute;
	top: 15px;
	width: 96px;
}

.rcdevsLogo img {
	object-fit: contain;
}

greenTick {
	display: inline-block;
	font-size: 150px;
	color: green;
	margin-top: 100px;
	margin-bottom: 100px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/rcdevsNxC.css"],"names":[],"mappings":"AAAA;CACC,8BAA8B;CAC9B,wBAAwB;CACxB,4BAA4B;CAC5B,2BAA2B;CAC3B,6BAA6B;;AAE9B;;AAEA;CACC,YAAY;CACZ,UAAU;CACV,kBAAkB;CAClB,SAAS;CACT,WAAW;AACZ;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,qBAAqB;CACrB,gBAAgB;CAChB,YAAY;CACZ,iBAAiB;CACjB,oBAAoB;AACrB","sourcesContent":[":root {\r\n\t--color-success-front: #30b471;\r\n\t--color-warning: #c69347;\r\n\t--color-error-front: #721c24;\r\n\t--color-error-back: #f8d7da;\r\n\t--color-error-border: #f5c6cb;\r\n\r\n}\r\n\r\n.rcdevsLogo {\r\n\theight: 44px;\r\n\tleft: 15px;\r\n\tposition: absolute;\r\n\ttop: 15px;\r\n\twidth: 96px;\r\n}\r\n\r\n.rcdevsLogo img {\r\n\tobject-fit: contain;\r\n}\r\n\r\ngreenTick {\r\n\tdisplay: inline-block;\r\n\tfont-size: 150px;\r\n\tcolor: green;\r\n\tmargin-top: 100px;\r\n\tmargin-bottom: 100px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
